import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'RegisterCompleted',
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState('user', {
      resending: ({ resending }) => resending,
    }),
  },
  beforeRouteEnter(to, from, next) {
    const email = to.params?.email;
    if (!email) {
      next('/register');
    } else {
      next();
    }
  },
  mounted() {
    this.email = this.$route.params?.email;
  },
  methods: {
    ...mapActions('user', {
      resendEmail: 'RESEND_VERIFY_EMAIL',
    }),
    async resend() {
      try {
        await this.resendEmail(this.email);
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, msg: '驗證信重發成功。' });
      } catch (error) {
        const { message } = error;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg: `驗證信重發失敗。(錯誤：${message})` });
      }
    },
  },
};
